'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var styles = _ref.styles;
  var rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      justifyContent = _ref2.justifyContent;

  var defaultStyles = {
    loading: {
      textAlign: 'center',
      fontSize: scale(2)
    },

    state: _extends({
      display: 'flex',
      alignItems: 'flex-start'
    }, justifyContent('center'), {
      padding: rhythm(2),
      fontSize: scale(-1),

      '& > *': {
        margin: rhythm([0, 0.25])
      }
    })
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/search-results/styles.js
// module id = 866
// module chunks = 0